import React, { Component } from 'react';

import {
	Panel,
	ListGroup,
	ListGroupItem,
	Button,
	Glyphicon,
} from 'react-bootstrap';

import translator from '../../../components/localization/translator';

class CollapseList extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isOpen: this.props.expanded,
			name: '',
			crateName: false,
		};
		this.renderList = this.renderList.bind(this);
		this.setArrows = this.setArrows.bind(this);
	}

	renderList(item, id) {
		if (typeof item === 'object'){
			const location = item.location ? item.location.address : '';
			const name = location ? (item.name - location) : item.name;
			return(
				<ListGroupItem key={id}>{name}</ListGroupItem>
			);
		}
		return(
			<ListGroupItem key={id}>
				{item}
			</ListGroupItem>
		);
	}

	isCollapsed() {
		this.setState({
			isOpen: !this.state.isOpen
		});
	}

	renderCreateBranch() {
		if (!this.state.crateName) {
			return null;
		}
		return(
			<div className={'margin-for-input flex-box'}>
				<input className={'form-control my-custom-input'}
					value={this.state.name}
					onChange={(e) => {
						this.setState({ name: e.target.value})
					}} />
				<Button className={'margin-to-left'}
					onClick={() => {
						if (this.state.name) {
							this.props.addBranch(this.state.name);
							this.setState({
								crateName: false,
								name: '',
							});
						}
					}}
					disabled={!this.state.name}>
					{translator.translate('_save_')}
				</Button>
			</div>
		);
	}

	renderAddBranch() {
		return(
			<Button
				className={'add-product margin-top-left'}
				bsStyle={'primary'}
				onClick={() => {
					this.setState({ crateName: true });
				}}>
				<Glyphicon glyph={'plus-sign'} />
				<span className={'margin-to-left'}>{translator.translate('_add_branch_')}</span>
			</Button>
		);
	}

	renderListGroup() {
		const {isList, list, child} = this.props;
		let className = this.state.isOpen ? 'show' : 'hidden';
		if (isList) {
			return(
				<ListGroup fill='true' className={`${className}`}>
					{list.map(this.renderList)}
				</ListGroup>
			);
		}
		if(child) {
			className += ' child-container'
		}

		if(this.props.childClassName) {
			className += ` ${this.props.childClassName}`;
		}
		return(
			<div fill='true' className={'comments scrollable ' + className}>
				<span>{list}</span>
				{this.renderAddBranch()}
				{this.renderCreateBranch()}
				{child}
			</div>
		);
	}

	setArrows() {
		let className = 'glyphicon-chevron-down';
		if (this.state.isOpen) {
			className = 'glyphicon-chevron-up';
		}
		return className;
	}

	renderHeader() {
		return(
			<div onClick={() => this.isCollapsed()}>
				<span>{this.props.headerTitle}</span>
				<span className={"glyphicon pull-right " + this.setArrows()}>
				</span>
			</div>
		);
	}

	render() {
		return (
			<Panel
				defaultExpanded={this.props.expanded}
				header={this.renderHeader()}
				className="pointer">
				{this.renderListGroup()}
			</Panel>
		);
	}
}

export default CollapseList;